import { createContext } from 'react';
export var defaultTableMultiBody = false;
export var tableMultiBodyContext = createContext(defaultTableMultiBody);
